export const BASE_URL = "https://lime-lazy-capybara.cyclic.app"
